import { axiosPrivate } from "../api/axios";
import { useContext, useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import AuthContext from "../context/AuthProvider";

const useAxiosPrivate = () => {
    const { auth, currentTenant } = useContext(AuthContext);
    const refresh = useRefreshToken();

    useEffect(() => {

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth.access_token}`;
                }

                // Add tenant_id to requests when available
                // Priority: currentTenant from context (from consent) > URL parameter (for direct access)
                // const tenantId = currentTenant?.id || getTenantIdFromUrl();
                // if (tenantId && !config.params?.tenant_id) {
                //     config.params = {
                //         ...config.params,
                //         tenant_id: tenantId
                //     };
                // }

                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    // Don't auto-retry for consent endpoints - let the component handle it
                    // This prevents using wrong tenant refresh tokens
                    const isConsentEndpoint = prevRequest?.url?.includes('/oauth/consent');
                    
                    if (isConsentEndpoint) {
                        console.log('useAxiosPrivate: Skipping auto-refresh for consent endpoint');
                        return Promise.reject(error);
                    }
                    
                    prevRequest.sent = true;
                    try {
                        const newAccessToken = await refresh();
                        prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        return axiosPrivate(prevRequest);
                    } catch (refreshError) {
                        // If refresh fails, reject with the original error
                        return Promise.reject(error);
                    }
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [refresh, auth, currentTenant])

    return axiosPrivate;
}

export default useAxiosPrivate;